import styled from "styled-components";
import { Link } from "react-router-dom";
import {
  siteDarkGreen,
  siteDarkBlue,
  siteLightBlue
} from "../../providers/Theme";
import HolographicBg from "../../assets/KRF-holographic-bg.jpg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  BODY_FONT_SIZE,
  bodyFontBase,
  bodyFontMd,
  buttonFontSize
} from "../../pages/shared.styled.components";

// ── Quote Band ────────────────────────────────────────────────────────────────

export const QuoteBand = styled.section`
  background: ${siteDarkBlue};
  padding: 2.75rem 2rem;
  text-align: center;

  ${({ theme }) => theme.md`
    padding: 3rem 5rem;
  `}

  ${({ theme }) => theme.lg`
    padding: 3rem 8rem;
  `}
`;

export const QuoteText = styled.p`
  color: white;
  font-style: italic;
  font-size: ${bodyFontBase};
  line-height: 1.7;
  margin-bottom: 0.75rem;

  ${({ theme }) => theme.md`
    font-size: ${bodyFontMd};
  `}
`;

export const QuoteAttribution = styled.p`
  color: white;
  font-size: ${bodyFontBase};
  margin: 0;
`;

// ── Intro Section ─────────────────────────────────────────────────────────────

export const IntroSection = styled.section`
  background: white;
  padding: 3.5rem 2rem;

  ${({ theme }) => theme.md`
    padding: 4rem;
  `}

  ${({ theme }) => theme.lg`
    padding: 4rem 5rem;
  `}
`;

export const IntroInner = styled.div`
  max-width: 72rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2.5rem;

  ${({ theme }) => theme.lg`
    flex-direction: row;
    align-items: center;
    gap: 3.5rem;
  `}
`;

export const IntroPhoto = styled.img`
  width: 100%;
  max-width: 320px;
  border-radius: 16px;
  object-fit: cover;
  display: block;
  margin: 0 auto;

  ${({ theme }) => theme.lg`
    flex: 0 0 340px;
    width: 340px;
    max-width: none;
    margin: 0;
  `}
`;

export const IntroContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const IntroHeading = styled.h1`
  color: ${siteDarkGreen};
  font-weight: 800;
  font-size: 2.6rem;
  margin-bottom: 1.25rem;

  ${({ theme }) => theme.md`
    font-size: 3rem;
  `}
`;

export const IntroBody = styled.p`
  color: #444;
  font-size: ${bodyFontBase};
  line-height: 1.75;
  margin-bottom: 1rem;
`;

export const IntroLink = styled.a`
  display: inline-block;
  color: ${siteLightBlue};
  font-size: ${bodyFontBase};
  font-weight: 600;
  text-decoration: none;
  margin-bottom: 1.75rem;

  &:hover {
    text-decoration: underline;
    color: ${siteLightBlue};
  }
`;

export const IntroButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`;

export const IntroButton = styled(Link)<{ $color: string }>`
  display: inline-block;
  background: ${({ $color }) => $color};
  color: white;
  font-weight: 700;
  font-size: ${buttonFontSize};
  text-decoration: none;
  border-radius: 0.5rem;
  padding: 0.7rem 2rem;
  transition: filter 0.15s ease;

  &:hover {
    filter: brightness(0.9);
    color: white;
  }
`;

// ── Indigo Child Section ──────────────────────────────────────────────────────

export const IndigoSection = styled.section`
  position: relative;
  z-index: 0;
  overflow: hidden;
  padding: 3rem 2rem;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: url(${HolographicBg});
    background-size: cover;
    background-position: center;
    opacity: 0.25;
    z-index: 0;
  }

  ${({ theme }) => theme.md`
    padding: 3.5rem 4rem;
  `}

  ${({ theme }) => theme.lg`
    padding: 4rem 5rem;
  `}
`;

export const IndigoSectionInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 72rem;
  margin: 0 auto;
`;

export const IndigoHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  margin-bottom: 0.6rem;

  ${({ theme }) => theme.md`
    font-size: 2.4rem;
  `}
`;

export const IndigoDateTag = styled.p`
  color: ${siteDarkBlue};
  font-style: italic;
  font-size: ${bodyFontBase};
  margin-bottom: 1.25rem;
`;

export const JournalEntryContainer = styled.div`
  background: ${siteDarkBlue};
  border-radius: 12px;
  padding: 1.75rem 2rem;
  margin-bottom: 2rem;

  p {
    color: white;
    font-size: ${bodyFontBase};
    line-height: 1.75;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const TextWrapper = styled.div`
  font-size: ${BODY_FONT_SIZE};
`;

export const GreenRow = styled(Row)`
  background-color: ${siteDarkGreen};
  color: white;
`;

export const TextCol = styled(Col).attrs({ className: "p-5" })``;
export const ImgCol = styled(Col).attrs({ className: "p-0" })``;
